
































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  public date = new Date();
  public dateRange = [new Date(2019, 4, 28), new Date()];
  public dateRange2 = [new Date(2019, 4, 28), new Date()];
  public defaultValue = [new Date(2019, 3, 1, 0, 0, 0), new Date()];
  public maxDate = new Date(Date.now() + 31536000000);
  public minDate = new Date(Date.now() - 5184000000);
  public value = false;

}
